import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import FeaturedProjects from '../components/FeaturedProjects';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { scrollToTarget } from '../lib/lenis';
import './Home.css';

const Home = () => {
  const scrollToContact = () => scrollToTarget('#contact');

  return (
    <main className="home">
      <Hero onContactClick={scrollToContact} />
      <About />
      <Experience />
      <FeaturedProjects />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
